import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export function NoResultsOverlay({
  children,
  message,
  isActive,
}: {
  children: ReactNode;
  message: string;
  isActive: boolean;
}) {
  return (
    <Box sx={{ position: 'relative' }}>
      <Box sx={{ opacity: isActive ? 0.3 : 1 }}>{children}</Box>
      {isActive && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'background.default',
            zIndex: 1,
            padding: 1.25,
            border: (theme) => `1px solid ${theme.palette.grey[400]}`,
          }}
        >
          <Typography variant="body3" sx={{ color: 'text.secondary' }}>
            {message}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
